<template>
    <div class="order_content_container">
        <spinner
            v-if="isOrder && isLoadFullInfo"
            :key="'spinner_order_content'"
        />
        <order_content_info
            v-if="isOrder && !isLoadFullInfo"
            :key="'order_content_info_general_' + activeOrderId"
            :typeInfo="'general'"
        />

    </div>
</template>

<script>
import order_content_header from "./OrderContentHeader.vue";
import order_content_info from "./OrderContentInfo.vue";
import {createHelpers} from "vuex-map-fields";
import spinner from "../../loader/Spinner.vue";

const {mapFields: mOrders} = createHelpers({
    getterType: 'orders/getOrdersField',
    mutationType: 'orders/updateOrdersField',
})

export default {
    name: "order_content",
    props: {
        isLoadFullInfo: {
            type: Boolean,
            required: true,
        },
        isOrder: {
            type:Boolean,
            required: true,
        },
    },
    emits: [],
    components: {
        spinner,
        order_content_header,
        order_content_info,
    },
    mixins: [],
    data() {
        return {}
    },
    methods: {},
    computed: {
        ...mOrders([
            'activeOrderFullInfo'
        ]),
        activeOrderId() {
            if (this.activeOrderFullInfo && this.activeOrderFullInfo.id) {
                return this.activeOrderFullInfo.id;
            }
            return '';
        }
    },
}
</script>
